// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nb-0";